<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col cols="12">
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
        >
          <b-form-checkbox
            id="status"
            v-model="filter.status"
            name="status"
            value="1"
            unchecked-value="0"
            switch
            @change="onFilterChanged"
          >
            <strong>Show Active Only?</strong>
          </b-form-checkbox>
          <br>
        </b-col>

        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Account
          </b-button>
        </b-col>
      </b-row>

      <b-table
        ref="table"
        hover
        responsive
        class="mt-2"
        :per-page="tableSettings.perPage"
        :current-page="tableSettings.currentPage"
        :items="myProvider"
        :fields="tableSettings.fields"
        :sort-by.sync="tableSettings.sortBy"
        :sort-desc.sync="tableSettings.sortDesc"
        :sort-direction="tableSettings.sortDirection"
        :filter="tableSettings.filter"
        :filter-included-fields="tableSettings.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{
            tableSettings.currentPage * tableSettings.perPage -
              tableSettings.perPage +
              (data.index + 1)
          }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active == 1 ? "Yes" : "No" }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditForm(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableSettings.perPage"
              :options="tableSettings.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableSettings.currentPage"
            :total-rows="tableSettings.totalRows"
            :per-page="tableSettings.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-user-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      @ok="onConfirmAction"
    >
      <ValidationObserver ref="form">
        <form
          role="form"
          novalidate
        >

          <ValidationProvider
            #default="{ errors }"
            name="email"
            vid="email"
            rules="required|email|max:100"
          >
            <b-form-group>
              <label for="email">Email</label>
              <b-input
                id="email"
                v-model="user.email"
                type="email"
                :state="errors.length > 0 ? false : null"
                placeholder="enter email"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="first name"
            vid="first_name"
            rules="required|max:50"
          >
            <b-form-group>
              <label for="first_name">First Name</label>
              <b-input
                id="first_name"
                v-model="user.first_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter first name"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="middle name"
            vid="middle_name"
            rules="max:50"
          >
            <b-form-group>
              <label for="middle_name">Middle Name</label>
              <b-input
                id="middle_name"
                v-model="user.middle_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter middle name"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="last name"
            vid="last_name"
            rules="required|max:50"
            :disabled="state.busy"
          >
            <b-form-group>
              <label for="last_name">Last Name</label>
              <b-input
                id="last_name"
                v-model="user.last_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter last name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password"
            vid="password"
            :rules="passwordRule"
          >
            <b-form-group>
              <label
                for="password"
              >Password
                <span
                  v-if="state.editing"
                >(Leave blank when not changing password)</span></label>
              <b-input
                id="password"
                v-model="user.password"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="password confirmation"
            vid="password_confirmation"
            :rules="passwordConfirmationRule"
          >
            <b-form-group>
              <label for="password_confirmation">Password Confirmation <span v-if="state.editing">(Leave blank when not changing password)</span></label>
              <b-input
                id="password_confirmation"
                v-model="user.password_confirmation"
                type="password"
                :state="errors.length > 0 ? false : null"
                placeholder="enter password confirmation"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="mobile number"
            vid="mobile_number"
            rules="min:11|max:11"
          >
            <b-form-group>
              <label for="mobile_number">Mobile Number</label>
              <b-input
                id="mobile_number"
                v-model="user.mobile_number"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
                placeholder="enter mobile number"
                autocomplete="off"
                maxlength="11"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="notification email"
            vid="notification_email"
            rules=""
          >
            <b-form-group>
              <label for="notification_email">Notification Email</label>
              <b-input
                id="notification_email"
                v-model="user.notification_email"
                type="email"
                :state="errors.length > 0 ? false : null"
                placeholder="enter notification email"
                autocomplete="off"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="user scope"
            vid="user_scope"
            rules="required"
          >
            <div class="form-group">
              <label for="role">Scope</label>
              <b-form-select
                id="user_scope"
                v-model="user.user_scope"
                :options="list.scopes"
                type="text"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Scope --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="provinces"
            vid="provinces"
          >
            <b-form-group>
              <label for="provinces">
                <strong>Provinces</strong>
              </label>
              <v-select
                id="provinces"
                v-model="user.provinces"
                :options="list.provinces"
                label="province_name"
                multiple
                :class="[errors.length > 0 ? ' is-invalid' : '']"
                placeholder=" -- Please Select Provinces -- "
                :disabled="state.busy || user.user_scope === null || user.user_scope !== 'retail'"
              >
                <template #option="{ province_name }">
                  <span>{{ province_name }}</span>
                </template>
                <template #no-options="">
                  No Available Provinces
                </template>
              </v-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="municipalities"
            vid="municipalities"
          >
            <b-form-group>
              <label for="municipalities">
                <strong>Municipalities</strong>
              </label>
              <v-select
                id="municipalities"
                v-model="user.municipalities"
                :options="list.municipalities"
                label="municipality_name"
                multiple
                :class="[errors.length > 0 ? ' is-invalid' : '']"
                placeholder=" -- Please Select Municipalities -- "
                :disabled="state.busy || user.user_scope === null || user.user_scope !== 'retail'"
              >
                <template #option="{ municipality_name }">
                  <span>{{ municipality_name }}</span>
                </template>
                <template #no-options="">
                  No Available Municipalities
                </template>
              </v-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing && user.id !== 1"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="user.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
            >
              Is Active?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? "Update Record" : "Save Record" }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { SharedListService, AxiosError, AdminUserAccountService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminUserAccounts',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Accounts'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      filter: {
        status: 0
      },
      list: {
        scopes: [
          { text: 'Employee', value: 'employee' },
          { text: 'Government', value: 'government' },
          { text: 'Research Field Officer', value: 'rfo' },
          { text: 'Retail', value: 'retail' }
        ],
        provinces: [],
        municipalities: []
      },
      user: {
        id: 0,
        active: 0,
        email: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        password: '',
        password_confirmation: '',
        mobile_number: '',
        notification_email: '',
        user_scope: 'employee',
        provinces: [],
        municipalities: []
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          {
            key: 'created_at',
            formatter: this.dateTimeFormatter,
            sortable: true
          },
          { key: 'email', sortable: true },
          { key: 'first_name', sortable: true },
          { key: 'middle_name', sortable: true },
          { key: 'last_name', sortable: true },
          { key: 'mobile_number', sortable: true },
          { key: 'notification_email', sortable: true },
          { key: 'user_scope', formatter: this.findUserScope },
          { key: 'active', label: 'IS ACTIVE?' },
          {
            key: 'updated_at',
            formatter: this.dateTimeFormatter,
            sortable: true
          }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.state.editing ? 'Edit Account' : 'Add Account'
    },

    passwordRule () {
      return `${this.state.editing ? '' : 'required|'}min:8|confirmed:password_confirmation`
    },

    passwordConfirmationRule () {
      return `${this.state.editing ? '' : 'required'}`
    }
  },

  watch: {
    'user.user_scope' (value) {
      if (value !== 'retail') {
        this.user.provinces = []
        this.user.municipalities = []
      }
    },

    'user.provinces' (provinces) {
      this.list.municipalities = []

      const arrayProvinces = provinces.map(item => { return item.id })

      this.user.municipalities = _.remove(this.user.municipalities, function (item) {
        return arrayProvinces.includes(item.province_id)
      })

      if (provinces.length > 0) {
        this.getMunicipalities(provinces.map(item => { return `province_id[]=${item.id}` }).join('&'))
      }
    }
  },

  mounted () {
    core.index()
    this.getProvinces()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await AdminUserAccountService.get(
          this.objectToUrl({
            page: ctx.currentPage,
            per_page: ctx.perPage,
            sort: ctx.sortBy,
            sort_desc: ctx.sortDesc,
            filter_text: ctx.filter,
            filter_status: this.filter.status
          })
        )
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    async getProvinces () {
      await SharedListService.getProvinces().then(({ data }) => {
        this.list.provinces = data
      })
    },

    async getMunicipalities (provinces) {
      await SharedListService.getMunicipalities(provinces).then(({ data }) => {
        this.list.municipalities = data
      })
    },

    findUserScope (val) {
      const scopeIndex = this.list.scopes.findIndex(scope => scope.value === val)
      return this.list.scopes[scopeIndex].text
    },

    onShowAddForm () {
      this.state.editing = false
      this.user.id = 0
      this.user.active = 1
      this.user.email = ''
      this.user.first_name = ''
      this.user.middle_name = ''
      this.user.last_name = ''
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.notification_email = ''
      this.user.mobile_number = ''
      this.user.user_scope = 'employee'
      this.user.provinces = []
      this.user.municipalities = []
      this.$bvModal.show('modal-user-form')
    },

    onShowEditForm (current) {
      this.state.editing = true
      this.user.id = current.id
      this.user.active = current.active
      this.user.email = current.email
      this.user.first_name = current.first_name
      this.user.middle_name = current.middle_name
      this.user.last_name = current.last_name
      this.user.password = ''
      this.user.password_confirmation = ''
      this.user.last_name = current.last_name
      this.user.mobile_number = current.mobile_number
      this.user.notification_email = current.notification_email
      this.user.user_scope = current.user_scope
      this.user.provinces = current.provinces?.map(item => { return item }) || []
      this.user.municipalities = current.municipalities?.map(item => { return item }) || []
      this.$bvModal.show('modal-user-form')
    },

    async onConfirmAction (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          let title = 'Do you really want to create account?'
          if (this.state.editing) {
            title = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: title,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              if (this.state.editing) {
                return this.onFormPutSubmit()
              } else {
                return this.onFormPostSubmit()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            centered: true
          })
        }
      })
    },

    async onFormPostSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        AdminUserAccountService.post(this.user).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-user-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.table.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    },

    async onFormPutSubmit () {
      return new Promise(resolve => {
        this.state.busy = true
        AdminUserAccountService.put(this.user).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-user-form')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.table.localItems, { id: data.user.id })
            row.active = data.user.active
            row.email = data.user.email
            row.first_name = data.user.first_name
            row.middle_name = data.user.middle_name
            row.last_name = data.user.last_name
            row.mobile_number = data.user.mobile_number
            row.notification_email = data.user.notification_email
            row.user_scope = data.user.user_scope
            row.provinces = data.user.provinces
            row.municipalities = data.user.municipalities
            row.updated_at = data.user.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          if (error instanceof AxiosError) {
            if (error.code === 422) {
              this.$refs.form.setErrors(error.message)
              resolve(error)
            }
          }
        })
      })
    },

    onFilterChanged () {
      this.$refs.table.refresh()
    }
  }
}
</script>
